
import { useIsDesktop } from 'common/MediaQueries';
import CarIcon from 'reusable/icons/hamesayat/CarIcon';
import { StyledBody } from 'reusable/wrappers/BodyText';

import ModalHeader from './ModalHeader';


const RepairModal = () => {
    const isDesktop = useIsDesktop()
    return (
        <>
            <ModalHeader icon={<CarIcon />} title="העמדת רכב חלופי" subtitle="שירות ללא חיוב" />
            <StyledBody $margin={isDesktop ? 30 : 20}>א. הרכב החלופי יסופק לתקופה שאינה עולה על 7 ימים.</StyledBody>
            <StyledBody $margin={isDesktop ? 30 : 1}>ב. הרכב החלופי יסופק רק במידה שהתאונה תתוקן במרכז שירות מורשה מטעם חברת דלק מוטורס והמשתתף בתוכנית.</StyledBody>
        </>
    )
}

export default RepairModal;
